import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  redirect: () => import("/vercel/path0/middleware/redirect.ts")
}